export default __webpack_public_path__ + "c97968020093632bb4b1bba443b95d4b.svg";